export default {
  CONFIG: 'CONFIG',
  ACTIVE: 'ACTIVE',
  DEFAULT: 'DEFAULT'
};
